module.exports = require("redux");


//////////////////
// WEBPACK FOOTER
// external "redux"
// module id = 381
// module chunks = 0